<div class="flex flex-col gap-2">
  <div
    style="
      display: flex;
      justify-content: flex-end;
      margin-bottom: 1rem;
      margin-right: 1rem;
    "
  >
    <button
      hsButton
      [hsButtonSize]="'sm'"
      [hsButtonVariant]="'filled'"
      (click)="resetTemplate()"
    >
      Standardeinstellungen wiederherstellen
    </button>
  </div>

  @if (templateTask()) {
    <kfm-sales-details [salesItem]="templateTask()!" [hsLayer]="'two'" />
  } @else {
    <kfm-sales-details [salesItem]="" [hsLayer]="'two'" />
  }
</div>
